// vueui/src/utils/cleanup.ts

// Global cleanup functions for when user logs out
let pdfCleanupFunction: (() => void) | null = null
let buildStatusCleanupFunction: (() => void) | null = null

export const registerPdfCleanup = (cleanupFn: () => void) => {
  pdfCleanupFunction = cleanupFn
}

export const registerBuildStatusCleanup = (cleanupFn: () => void) => {
  buildStatusCleanupFunction = cleanupFn
}

export const cleanupOnLogout = () => {
  if (pdfCleanupFunction) {
    console.log('🧹 Running PDF cleanup on logout')
    pdfCleanupFunction()
  }
  if (buildStatusCleanupFunction) {
    console.log('🧹 Running build status cleanup on logout')
    buildStatusCleanupFunction()
  }
}
